module.exports = __webpack_public_path__ + "img/vc3.04979d17.png";